import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxRowComponent } from './rx-row.component';

@NgModule({
  imports: [CommonModule, RxRowComponent],
  exports: [RxRowComponent],
})
export class RxRowModule {}
